import React from 'react';
import { formatDate, formatDateRange } from './helper';

const EventCard = ({ event, isSelected, onClick }) => {

  const startDate = formatDate(event.conference_start_date);
  const dateRange = formatDateRange(event.conference_start_date, event.conference_end_date);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onClick(event)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick(event);
        }
      }}
      className={`transition-colors 
                  duration-150 ease-in-out rounded-all_48
                  cursor-pointer 
                  h-[169px] p-10 border-gradient-events
                  hover:border-gradient-events-hover max-w-[445px] w-full
                  ${
                    isSelected
                      ? 'bg-soft_green' 
                      : 'bg-transparent'
                  }`}
    >
      {/* Event Card */}
      <div className="flex items-center h-full w-full">
        {/* Date Display */}
        <div className="hidden lg:flex flex-shrink-0 w-16 h-16 flex-col items-center justify-center">
          <h2 className="text-h2 text-dark_green font-bold">
            {startDate.month}
          </h2>
          <div className="flex items-baseline">
            <h2 className="text-h2 text-dark_green font-bold">
              {startDate.day}{startDate.ordinal}
            </h2>
          </div>
        </div>

        {/* Vertical Divider */}
        <div className="hidden lg:block w-[1px] h-full mx-[40px] bg-separator/60"></div>

        {/* Event Details */}
        <div className="flex-1 min-w-0">
          <h4 className="text-h4_medium text-dark_green font-bold">
            {event.conference_id}
          </h4>
          <div className="text-sm text-text_paragraph  my-[10px]">
            {dateRange}
          </div>
          <div className="text-sm text-text_paragraph font-bold">
            {event.conference_city}, {event.conference_state}
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default EventCard;
